import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from './Component/Dashboard';
import PreviewDownload from './Component/PreviewDownload';
import Privacidad from './Component/Privacidad';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/preview" element={<PreviewDownload />} />
        <Route path="/privacidad" element={<Privacidad />} />
      </Routes>
    </Router>
  );
};

export default App;